module.exports = __webpack_public_path__ + "img/icone-conexao.d9586af3.svg";